<a class="home-image-wrapper" [routerLink]="getLink(homeImage)" routerLinkActive="is-active">
  <img [src]="homeImage.imageUrl" />
  <span class="home-image-title">{{ homeImage.title | uppercase }}</span>
  <span class="shop-now">SHOP NOW</span>
</a>

<div class="shop-by-category-wrapper">
  <span class="shop-by-category-title">SHOP BY CATEGORY</span>
  <div class="categories-wrapper">
    <a class="category" *ngFor="let category of categories" [routerLink]="getLink(category)" routerLinkActive="is-active">
      <img #categoryImage [src]="category.imageUrl" [style.height.px]="categoryImgHeight" />
      <span class="category-title">{{ category.title | titlecase }}</span>
    </a>
  </div>
</div>

<div class="more-categories-wrapper">
  <a class="category" *ngFor="let category of moreCategories" [routerLink]="getLink(category)" routerLinkActive="is-active">
    <img [src]="category.imageUrl" />
    <span class="category-title">{{ category.title }}</span>
  </a>
</div>
